import { Box } from '@mui/material';
import { CircleMinus, Download } from 'lucide-react';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { NestedMenuItem } from '~/components/Menu';
import MenuItem from '~/components/Menu/MenuItem';
import SidebarActionMenu from '~/components/Menu/SidebarActionMenu';
import usePatientDoses from '~/hooks/patient/dose/usePatientDoses';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { downloadDoseToDisk } from '~/utils/io/files/downloadDicom';

export default function DoseActionMenu() {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const selectedDose = useRecoilValue(currentDoseState);
    const { setEnvironmentDose, unloadDose } = useViewportEnvironment();
    const availableDoses = usePatientDoses();

    return (
        <Box mr={-0.5}>
            <SidebarActionMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
                {availableDoses.length > 0 && (
                    <NestedMenuItem label="Change">
                        {availableDoses.map((dose) => (
                            <MenuItem
                                key={dose.dicomUid}
                                label={
                                    dose.plan?.label ?? dose.doseSummationType
                                }
                                onClick={() => {
                                    setAnchorEl(null);
                                    setEnvironmentDose(
                                        [dose],
                                        selectedPatientId ?? ''
                                    );
                                }}
                            ></MenuItem>
                        ))}
                    </NestedMenuItem>
                )}

                <MenuItem
                    label="Download"
                    onClick={() => {
                        if (selectedDose) {
                            setAnchorEl(null);
                            downloadDoseToDisk(selectedDose);
                        }
                    }}
                    icon={<Download size={16} />}
                />
                <MenuItem
                    label="Unload"
                    onClick={() => {
                        setAnchorEl(null);
                        unloadDose();
                    }}
                    icon={<CircleMinus size={16} />}
                />
            </SidebarActionMenu>
        </Box>
    );
}
